var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1196_9038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8806 11.454C19.2952 10.174 16.9999 6 11.9999 6C6.99988 6 4.70455 10.174 4.11922 11.454C4.04064 11.6255 3.99997 11.812 3.99997 12.0007C3.99997 12.1893 4.04064 12.3758 4.11922 12.5473C4.70455 13.826 6.99988 18 11.9999 18C16.9999 18 19.2952 13.826 19.8806 12.546C19.959 12.3747 19.9996 12.1884 19.9996 12C19.9996 11.8116 19.959 11.6253 19.8806 11.454ZM11.9999 16C11.2088 16 10.4354 15.7654 9.7776 15.3259C9.11981 14.8864 8.60712 14.2616 8.30437 13.5307C8.00162 12.7998 7.9224 11.9956 8.07674 11.2196C8.23108 10.4437 8.61205 9.73098 9.17146 9.17157C9.73087 8.61216 10.4436 8.2312 11.2195 8.07686C11.9954 7.92252 12.7997 8.00173 13.5306 8.30448C14.2615 8.60723 14.8862 9.11992 15.3258 9.77772C15.7653 10.4355 15.9999 11.2089 15.9999 12C15.9988 13.0605 15.5771 14.0773 14.8271 14.8273C14.0772 15.5772 13.0604 15.9989 11.9999 16Z",
    fill: "#9A9EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 14.6665C13.4729 14.6665 14.6668 13.4725 14.6668 11.9998C14.6668 10.527 13.4729 9.33313 12.0001 9.33313C10.5273 9.33313 9.33344 10.527 9.33344 11.9998C9.33344 13.4725 10.5273 14.6665 12.0001 14.6665Z",
    fill: "#9A9EA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1196_9038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye_on.3a61f78b963d836ac5d8406cba99e0e1.svg";
export { ForwardRef as ReactComponent };